import React, { useState, useEffect } from "react"
import { Layout, Menu, Select, Switch, Tabs } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";


const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const Meditation
    = () => {

        const [modal1Open, setModal1Open] = useState(false);



        const navigate = useNavigate()

        // switch
        const onChange3 = (checked) => {
            console.log(`switch to ${checked}`);
        };

        //   


        useEffect(() => {
            document.title = 'MentalFit';
        }, [])



        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Meditation</h1>
                            <Breadcrumb separator=">">

                                <Breadcrumb.Item>
                                    <Link to="/tools"> Tools </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {appconstant.meditation}
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </div>



                    <section>
                        <div className=" manage-table-data">
                            <div className="log-moode-page-sec">
                                <div className="log-mood">
                                    <div onClick={() => { setModal1Open(true) }} className="new-mood-add">
                                        <div className="add-image-mood">
                                            <img src={images.meditation} alt="logMood" />
                                        </div>
                                        <div className="new-mood-text">
                                            <p><span> <img src={images.add} alt="add" /></span>Add new meditation</p>
                                        </div>
                                    </div>

                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.shape} alt="shape" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Guided Breath Work</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.shapeTwo} alt="shapeTwo" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Waking up</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.shapeThree} alt="shapeThree" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1>Let Go</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.shapeFour} alt="shapeFour" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1> Unwind</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.shapeFive} alt="shapeFive" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1> Wind Down</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="best-possible">
                                        <div className="inner-possible-box">
                                            <div className="best-emoji">
                                                <img src={images.shapeSix} alt="shapeSix" />
                                            </div>
                                            <div className="best-poss-heading">
                                                <h1> Lazing Lagoon</h1>
                                                <div className="edit-and-delete">
                                                    <p> <span><img src={images.moodEdit} alt="moodEdit" /></span> Edit </p>
                                                    <p> <span><img src={images.deleteIcon} alt="deleteIcon" /></span> Delete </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                 
                                </div>
                            </div>
                        </div>
                    </section>



                </div>

                {/* Add new Meditation */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal1Open}
                    closable={true}
                    onCancel={() => setModal1Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Add new Meditation </h1>
                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group">
                                    <label>{appconstant.meditationTitle}</label>
                                    <Textfiled
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Emotion Title'
                                    />
                                </div>

                                <div className="form-group">
                                    <div className="textarea-label">
                                        <label>{appconstant.meditationDetail}</label>
                                      
                                    </div>
                                    <textarea
                                        rows="5" cols="50"
                                        className='form-control-textarea'
                                        type='textarea'
                                        placeholder='Enter Detail here' />
                                </div>
                            </div>
                        </div>


                        <div className="add-sugg-activity">

                            <div className="click-to-upload label-top-space">
                                <label>Upload Icons</label>
                                <div className="upload-file new-up-file label-less-margin">
                                    <div className="upload-center-text add-up-activity">
                                        <p><span><img src={images.upload} alt="upload" /></span> Click here to upload </p>
                                    </div>

                                    <p className="image-disp">File Format: .JPEG, .PNG</p>

                                </div>
                            </div>

                            <div className="upload-icons-text">
                                <label>Upload Audio</label>
                                <div className="click-here-to-up">
                                    <p>Click here to upload audio</p>
                                    <img src={images.upload} alt="upload" />

                                </div>

                            </div>
                        </div>

                        <div className="best-png">
                            <div className="relationship">
                                <p><span><img className="best-emoji-mod" src={images.music} alt=""/></span> Meditation audio .mp3<span><img src={images.singleCross} alt="singleCross" /></span></p>
                            </div>
                        </div>

                        <div className="click-to-upload">
                            <div className="add-activity-button">
                                <button>Add Meditation</button>
                            </div>
                        </div>





                    </div>
                </Modal>


                 



            </div>

        )
    }
export default Meditation

